module.exports = __webpack_public_path__ + "img/common-popup-hen.436f48b8.png";